import ReducerRegistry from "../base/redux/ReducerRegistry";
import { SET_SPOKEN_LANGUAGE } from "./actionTypes";
const DEFAULT_STATE = {
    spokenLanguage: undefined,
};
/**
 * Reducer for the translation feature state.
 */
ReducerRegistry.register("features/translation", (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_SPOKEN_LANGUAGE:
            return {
                ...state,
                spokenLanguage: action.language,
            };
        default:
            return state;
    }
});
